import {
  ShoppingCart,
  UtensilsCrossed,
  Sparkles,
  Smartphone,
  Gift,
  MapPin,
  Wrench,
  Zap,
  Store,
  Wallet,
  ShieldCheck,
  Headset,
  Truck,
  Heart,
  Package,
} from "lucide-react";

export const ICONS = {
  ShoppingCart,
  UtensilsCrossed,
  Sparkles,
  Smartphone,
  Gift,
  MapPin,
  Wrench,
  Zap,
  Store,
  Wallet,
  ShieldCheck,
  Headset,
  Truck,
  Heart,
  Package,
};

export const ICON_NAMES = Object.keys(ICONS);
export const getIcon = (name, fallback = Gift) => ICONS[name] || fallback;
